export default __webpack_public_path__ + "static/media/pause-button@2x.a67344ec.png";